/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CompetitionCreate,
  CompetitionPdfImport,
  CompetitionProblemRead,
  CompetitionProblemUpdate,
  CompetitionProblemsReplace,
  CompetitionRead,
  CompetitionUpdate,
  HTTPValidationError,
  PaginatedCompetitionsResponse,
  StatementUpdateResult,
  StatementUpdates,
} from '../models/index';
import {
    CompetitionCreateFromJSON,
    CompetitionCreateToJSON,
    CompetitionPdfImportFromJSON,
    CompetitionPdfImportToJSON,
    CompetitionProblemReadFromJSON,
    CompetitionProblemReadToJSON,
    CompetitionProblemUpdateFromJSON,
    CompetitionProblemUpdateToJSON,
    CompetitionProblemsReplaceFromJSON,
    CompetitionProblemsReplaceToJSON,
    CompetitionReadFromJSON,
    CompetitionReadToJSON,
    CompetitionUpdateFromJSON,
    CompetitionUpdateToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    PaginatedCompetitionsResponseFromJSON,
    PaginatedCompetitionsResponseToJSON,
    StatementUpdateResultFromJSON,
    StatementUpdateResultToJSON,
    StatementUpdatesFromJSON,
    StatementUpdatesToJSON,
} from '../models/index';

export interface CreateCompetitionRequest {
    competitionCreate: CompetitionCreate;
}

export interface DeleteCompetitionRequest {
    competitionId: string;
}

export interface GetCompetitionRequest {
    competitionId: string;
}

export interface GetCompetitionProblemsRequest {
    competitionId: string;
}

export interface GetCompetitionsRequest {
    leagueId?: string | null;
    seasonId?: string | null;
    isPublic?: boolean | null;
    search?: string | null;
    skip?: number;
    limit?: number;
    sortBy?: GetCompetitionsSortByEnum;
    sortOrder?: GetCompetitionsSortOrderEnum;
}

export interface ImportCompetitionRequest {
    statements?: Blob | null;
    testData?: Blob | null;
    solutions?: Blob | null;
}

export interface ReplaceCompetitionProblemsRequest {
    competitionId: string;
    competitionProblemsReplace: CompetitionProblemsReplace;
}

export interface UpdateCompetitionRequest {
    competitionId: string;
    competitionUpdate: CompetitionUpdate;
}

export interface UpdateCompetitionProblemRequest {
    competitionId: string;
    problemId: string;
    competitionProblemUpdate: CompetitionProblemUpdate;
}

export interface UpdateCompetitionStatementsRequest {
    competitionId: string;
    statementUpdates: StatementUpdates;
}

/**
 * 
 */
export class CompetitionsApi extends runtime.BaseAPI {

    /**
     * Create a competition owned by the caller; competition organizers and superadmins only.
     * Create Competition
     */
    async createCompetitionRaw(requestParameters: CreateCompetitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitionRead>> {
        if (requestParameters['competitionCreate'] == null) {
            throw new runtime.RequiredError(
                'competitionCreate',
                'Required parameter "competitionCreate" was null or undefined when calling createCompetition().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/competitions/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompetitionCreateToJSON(requestParameters['competitionCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompetitionReadFromJSON(jsonValue));
    }

    /**
     * Create a competition owned by the caller; competition organizers and superadmins only.
     * Create Competition
     */
    async createCompetition(requestParameters: CreateCompetitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitionRead> {
        const response = await this.createCompetitionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a competition; organizer only (own competition), 409 while it has events.
     * Delete Competition
     */
    async deleteCompetitionRaw(requestParameters: DeleteCompetitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['competitionId'] == null) {
            throw new runtime.RequiredError(
                'competitionId',
                'Required parameter "competitionId" was null or undefined when calling deleteCompetition().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/competitions/{competition_id}`.replace(`{${"competition_id"}}`, encodeURIComponent(String(requestParameters['competitionId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a competition; organizer only (own competition), 409 while it has events.
     * Delete Competition
     */
    async deleteCompetition(requestParameters: DeleteCompetitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCompetitionRaw(requestParameters, initOverrides);
    }

    /**
     * Get one competition; any authenticated user who may read it, otherwise 404.
     * Get Competition
     */
    async getCompetitionRaw(requestParameters: GetCompetitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitionRead>> {
        if (requestParameters['competitionId'] == null) {
            throw new runtime.RequiredError(
                'competitionId',
                'Required parameter "competitionId" was null or undefined when calling getCompetition().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/competitions/{competition_id}`.replace(`{${"competition_id"}}`, encodeURIComponent(String(requestParameters['competitionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompetitionReadFromJSON(jsonValue));
    }

    /**
     * Get one competition; any authenticated user who may read it, otherwise 404.
     * Get Competition
     */
    async getCompetition(requestParameters: GetCompetitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitionRead> {
        const response = await this.getCompetitionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List a competition\'s problems in order; any authenticated user who may read it.
     * Get Competition Problems
     */
    async getCompetitionProblemsRaw(requestParameters: GetCompetitionProblemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompetitionProblemRead>>> {
        if (requestParameters['competitionId'] == null) {
            throw new runtime.RequiredError(
                'competitionId',
                'Required parameter "competitionId" was null or undefined when calling getCompetitionProblems().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/competitions/{competition_id}/problems`.replace(`{${"competition_id"}}`, encodeURIComponent(String(requestParameters['competitionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CompetitionProblemReadFromJSON));
    }

    /**
     * List a competition\'s problems in order; any authenticated user who may read it.
     * Get Competition Problems
     */
    async getCompetitionProblems(requestParameters: GetCompetitionProblemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompetitionProblemRead>> {
        const response = await this.getCompetitionProblemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List the competitions the caller may read; any authenticated user, filtered by visibility.
     * Get Competitions
     */
    async getCompetitionsRaw(requestParameters: GetCompetitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedCompetitionsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['leagueId'] != null) {
            queryParameters['league_id'] = requestParameters['leagueId'];
        }

        if (requestParameters['seasonId'] != null) {
            queryParameters['season_id'] = requestParameters['seasonId'];
        }

        if (requestParameters['isPublic'] != null) {
            queryParameters['is_public'] = requestParameters['isPublic'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sort_by'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sort_order'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/competitions/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedCompetitionsResponseFromJSON(jsonValue));
    }

    /**
     * List the competitions the caller may read; any authenticated user, filtered by visibility.
     * Get Competitions
     */
    async getCompetitions(requestParameters: GetCompetitionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedCompetitionsResponse> {
        const response = await this.getCompetitionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Import an archive round: any of the statements PDF, test data (PDF or zip), solutions zip.  Problems are merged by name; every missing piece is a warning on its draft. Competition organizers and superadmins with upload permission only. Returns 400 when no file is given, for a wrong file type per field, an unreadable PDF or zip, or a test-data zip without a PDF; 413 over the PDF or zip limits (Starlette has already spooled the upload to a temporary file; it is read into memory in pieces and never beyond the size limit); 422 when the statements or the test data have no problems; 502/503 when an AI call fails (one unreadable test-data section only warns).
     * Import Competition
     */
    async importCompetitionRaw(requestParameters: ImportCompetitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitionPdfImport>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['statements'] != null) {
            formParams.append('statements', requestParameters['statements'] as any);
        }

        if (requestParameters['testData'] != null) {
            formParams.append('test_data', requestParameters['testData'] as any);
        }

        if (requestParameters['solutions'] != null) {
            formParams.append('solutions', requestParameters['solutions'] as any);
        }

        const response = await this.request({
            path: `/judge/competitions/import`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompetitionPdfImportFromJSON(jsonValue));
    }

    /**
     * Import an archive round: any of the statements PDF, test data (PDF or zip), solutions zip.  Problems are merged by name; every missing piece is a warning on its draft. Competition organizers and superadmins with upload permission only. Returns 400 when no file is given, for a wrong file type per field, an unreadable PDF or zip, or a test-data zip without a PDF; 413 over the PDF or zip limits (Starlette has already spooled the upload to a temporary file; it is read into memory in pieces and never beyond the size limit); 422 when the statements or the test data have no problems; 502/503 when an AI call fails (one unreadable test-data section only warns).
     * Import Competition
     */
    async importCompetition(requestParameters: ImportCompetitionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitionPdfImport> {
        const response = await this.importCompetitionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace a competition\'s ordered problem list; organizer only (own competition).
     * Replace Competition Problems
     */
    async replaceCompetitionProblemsRaw(requestParameters: ReplaceCompetitionProblemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompetitionProblemRead>>> {
        if (requestParameters['competitionId'] == null) {
            throw new runtime.RequiredError(
                'competitionId',
                'Required parameter "competitionId" was null or undefined when calling replaceCompetitionProblems().'
            );
        }

        if (requestParameters['competitionProblemsReplace'] == null) {
            throw new runtime.RequiredError(
                'competitionProblemsReplace',
                'Required parameter "competitionProblemsReplace" was null or undefined when calling replaceCompetitionProblems().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/competitions/{competition_id}/problems`.replace(`{${"competition_id"}}`, encodeURIComponent(String(requestParameters['competitionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CompetitionProblemsReplaceToJSON(requestParameters['competitionProblemsReplace']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CompetitionProblemReadFromJSON));
    }

    /**
     * Replace a competition\'s ordered problem list; organizer only (own competition).
     * Replace Competition Problems
     */
    async replaceCompetitionProblems(requestParameters: ReplaceCompetitionProblemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompetitionProblemRead>> {
        const response = await this.replaceCompetitionProblemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Partially update a competition; organizer only, and it must be the caller\'s own.
     * Update Competition
     */
    async updateCompetitionRaw(requestParameters: UpdateCompetitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitionRead>> {
        if (requestParameters['competitionId'] == null) {
            throw new runtime.RequiredError(
                'competitionId',
                'Required parameter "competitionId" was null or undefined when calling updateCompetition().'
            );
        }

        if (requestParameters['competitionUpdate'] == null) {
            throw new runtime.RequiredError(
                'competitionUpdate',
                'Required parameter "competitionUpdate" was null or undefined when calling updateCompetition().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/competitions/{competition_id}`.replace(`{${"competition_id"}}`, encodeURIComponent(String(requestParameters['competitionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CompetitionUpdateToJSON(requestParameters['competitionUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompetitionReadFromJSON(jsonValue));
    }

    /**
     * Partially update a competition; organizer only, and it must be the caller\'s own.
     * Update Competition
     */
    async updateCompetition(requestParameters: UpdateCompetitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitionRead> {
        const response = await this.updateCompetitionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set a problem\'s points multiplier; organizer only, allowed after an event has started.
     * Update Competition Problem
     */
    async updateCompetitionProblemRaw(requestParameters: UpdateCompetitionProblemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitionProblemRead>> {
        if (requestParameters['competitionId'] == null) {
            throw new runtime.RequiredError(
                'competitionId',
                'Required parameter "competitionId" was null or undefined when calling updateCompetitionProblem().'
            );
        }

        if (requestParameters['problemId'] == null) {
            throw new runtime.RequiredError(
                'problemId',
                'Required parameter "problemId" was null or undefined when calling updateCompetitionProblem().'
            );
        }

        if (requestParameters['competitionProblemUpdate'] == null) {
            throw new runtime.RequiredError(
                'competitionProblemUpdate',
                'Required parameter "competitionProblemUpdate" was null or undefined when calling updateCompetitionProblem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/competitions/{competition_id}/problems/{problem_id}`.replace(`{${"competition_id"}}`, encodeURIComponent(String(requestParameters['competitionId']))).replace(`{${"problem_id"}}`, encodeURIComponent(String(requestParameters['problemId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CompetitionProblemUpdateToJSON(requestParameters['competitionProblemUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompetitionProblemReadFromJSON(jsonValue));
    }

    /**
     * Set a problem\'s points multiplier; organizer only, allowed after an event has started.
     * Update Competition Problem
     */
    async updateCompetitionProblem(requestParameters: UpdateCompetitionProblemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitionProblemRead> {
        const response = await this.updateCompetitionProblemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the statements of a competition\'s problems and add their missing example test cases.  Organizer of the competition or superadmin only; per problem the caller must also be allowed to modify it. Returns one result per requested problem (`updated`, `not_in_competition`, `not_owner`, `not_found`). 401 without a user, 403 for a non-organizer, 404 when the competition is missing or hidden, 422 for an empty list or more than 50 updates, 500 on a database error (nothing is written).
     * Update Competition Statements
     */
    async updateCompetitionStatementsRaw(requestParameters: UpdateCompetitionStatementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StatementUpdateResult>>> {
        if (requestParameters['competitionId'] == null) {
            throw new runtime.RequiredError(
                'competitionId',
                'Required parameter "competitionId" was null or undefined when calling updateCompetitionStatements().'
            );
        }

        if (requestParameters['statementUpdates'] == null) {
            throw new runtime.RequiredError(
                'statementUpdates',
                'Required parameter "statementUpdates" was null or undefined when calling updateCompetitionStatements().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/competitions/{competition_id}/statements`.replace(`{${"competition_id"}}`, encodeURIComponent(String(requestParameters['competitionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StatementUpdatesToJSON(requestParameters['statementUpdates']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StatementUpdateResultFromJSON));
    }

    /**
     * Update the statements of a competition\'s problems and add their missing example test cases.  Organizer of the competition or superadmin only; per problem the caller must also be allowed to modify it. Returns one result per requested problem (`updated`, `not_in_competition`, `not_owner`, `not_found`). 401 without a user, 403 for a non-organizer, 404 when the competition is missing or hidden, 422 for an empty list or more than 50 updates, 500 on a database error (nothing is written).
     * Update Competition Statements
     */
    async updateCompetitionStatements(requestParameters: UpdateCompetitionStatementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StatementUpdateResult>> {
        const response = await this.updateCompetitionStatementsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetCompetitionsSortByEnum = {
    Name: 'name',
    CreatedAt: 'created_at'
} as const;
export type GetCompetitionsSortByEnum = typeof GetCompetitionsSortByEnum[keyof typeof GetCompetitionsSortByEnum];
/**
 * @export
 */
export const GetCompetitionsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetCompetitionsSortOrderEnum = typeof GetCompetitionsSortOrderEnum[keyof typeof GetCompetitionsSortOrderEnum];
